import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgChatBubble = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.6018 3.00013C11.1049 2.99798 9.6346 3.39646 8.34361 4.15425C7.05262 4.91203 5.98794 6.00149 5.26007 7.30958C4.53219 8.61766 4.16764 10.0967 4.20424 11.5932C4.24085 13.0897 4.67727 14.5492 5.46823 15.8201L3.00183 21.0001L8.18102 18.5337C9.28558 19.2205 10.5345 19.6413 11.8295 19.7632C13.1244 19.885 14.4299 19.7045 15.6432 19.2358C16.8565 18.7671 17.9443 18.0231 18.821 17.0623C19.6978 16.1016 20.3394 14.9504 20.6955 13.6994C21.0515 12.4484 21.1121 11.1319 20.8727 9.85347C20.6332 8.57506 20.1001 7.36973 19.3154 6.33244C18.5307 5.29515 17.5159 4.45424 16.3509 3.87598C15.1859 3.29772 13.9025 2.99789 12.6018 3.00013V3.00013Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgChatBubble.displayName = 'SvgChatBubble';
export default SvgChatBubble;
